import type { ReactNode } from 'react';
import { createContext, useCallback, useContext, useEffect, useState } from 'react';
import type { OperationControl } from '../models';
import { fetchOperationControl } from '../repositories';

interface OperationControlContextProps {
  isStarted: boolean;
  fetchData: () => Promise<void>;
}

const OperationControlContext = createContext<OperationControlContextProps>({
  isStarted: false,
  fetchData: async () => {},
});

function OperationControlProvider({ children }: { children: ReactNode }) {
  const [operationControl, setOperationControl] = useState<OperationControl>({ isStarted: false });
  const [isDateFetchingEnd, setIsDateFetchingEnd] = useState(false);

  const fetchData = useCallback(async () => {
    setOperationControl(await fetchOperationControl());
    setIsDateFetchingEnd(true);
  }, []);

  useEffect(() => {
    void fetchData();
  }, [fetchData]);

  return (
    <OperationControlContext.Provider
      value={{
        isStarted: operationControl.isStarted,
        fetchData,
      }}
    >
      {isDateFetchingEnd ? children : null}
    </OperationControlContext.Provider>
  );
}

function useOperationControl() {
  return useContext(OperationControlContext);
}

export { OperationControlProvider, useOperationControl };
